import React, { useState } from "react";

import Arrow from "./img/arrow_back.svg";
import ArrowSelect from "./img/arrow_selector.svg";

import Close from "./img/close_multi.svg";

import "./style.scss";

const SelectingOptions = ({ item }) => {
    const [radio, setRadio] = useState(false);
    const [checked, setChecked] = useState([]);
    const [checkedSelect, setCheckedSelect] = useState([]);
    const [open, setOpen] = useState(false);

    const handleChecked = (value) => {
        let add = checked.some((it) => it.value === value.value);
        if (add) {
            setChecked(checked.filter((el) => el.value !== value.value));
        } else {
            setChecked((prev) => prev.concat(value));
        }
    };

    const handleCheckedSelect = (value) => {
        let add = checkedSelect.some((it) => it.value === value.value);
        if (add) {
            setCheckedSelect(checkedSelect.filter((el) => el.value !== value.value));
        } else {
            setCheckedSelect((prev) => prev.concat(value));
        }
    };

    const handleClickRadio = () => {
        let obj = item.options.find((el) => el.value === radio);
        formTemplateAnswerState([obj]);
    };

    const handleDelete = (e, elem) => {
        e.preventDefault();
        e.stopPropagation();
        let newArr = checkedSelect.filter((el) => el !== elem);
        setCheckedSelect(newArr);
    };

    const layoutRender = (layout, array) => {
        switch (layout) {
            case "buttons":
                return (
                    <div className={`selecting__options_answers ${layout}`}>
                        {array.map((el, index) => (
                            <div className={`buttons`} key={index}>
                                {el.text}
                            </div>
                        ))}
                    </div>
                );

            case "radioButtons":
                return (
                    <div className={`selecting__options_answers ${layout}`}>
                        {array.map((el, index) => (
                            <div className="radio" key={index}>
                                <input type="radio" value={el.value} checked={radio === el.value} onChange={(e) => setRadio(e.target.value)} />
                                <label className="label">{el.text}</label>
                            </div>
                        ))}
                        {radio ? (
                            <div className={`selecting__options_button`} onClick={() => handleClickRadio()}>
                                Выбрать
                            </div>
                        ) : null}
                    </div>
                );

            case "checkbox":
                return (
                    <div className={`selecting__options_answers ${layout}`}>
                        {array.map((el, index) => (
                            <div className="checklist" key={index}>
                                <div className={`checklist__checkbox  ${checked.find((it) => it.value === el.value) ? `checked` : ""}`} onClick={() => handleChecked(el)}></div>
                                <label className="label">{el.text}</label>
                            </div>
                        ))}

                        {checked.length ? <div className={`selecting__options_button ${checked.length ? "vizible" : ""}`}>Выбрать</div> : null}
                    </div>
                );

            case "selectSuggest":
                return (
                    <div className={`selecting__options_answers ${layout}`}>
                        <div className={`select ${checkedSelect.length ? "multi" : ""}`} onClick={() => setOpen(!open)}>
                            {checkedSelect.length ? (
                                checkedSelect.map((el, index) => (
                                    <div className="multi__el" key={index} onClick={() => setOpen(!open)}>
                                        <img src={Close} onClick={(e) => handleDelete(e, el)} />
                                        <span>{el.text}</span>
                                    </div>
                                ))
                            ) : (
                                <div className="select__block" onClick={() => setOpen(!open)}>
                                    <span className="selsect__title">Выберите ответ</span>
                                    <img src={ArrowSelect} />
                                </div>
                            )}
                        </div>
                        <div className={`select__list ${open ? "select__list_open" : ""}`}>
                            <div className="select__list-content">
                                {array.map((el, index) => (
                                    <div className="checklist" key={index} onClick={() => handleCheckedSelect(el)}>
                                        <div className={`checklist__checkbox ${checkedSelect.find((it) => it.value === el.value) ? "checked" : ""}`}></div>
                                        <label className="label">{el.text}</label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {checkedSelect.length ? <div className={`selecting__options_button ${checkedSelect.length ? "vizible" : ""}`}>Выбрать</div> : null}
                    </div>
                );
            case "city":
            case "region":
            case "metro":
                return (
                    <div className={`selecting__options_answers ${layout}`}>
                        <div className={`select`}>
                            {checkedSelect.length ? (
                                checkedSelect.map((el, index) => (
                                    <div className="multi__el" key={index}>
                                        <img src={Close} onClick={(e) => handleDelete(e, el)} />
                                        <span>{el.text}</span>
                                    </div>
                                ))
                            ) : (
                                <div className="select__block">
                                    <span className="selsect__title">Выберите {placeholders[layout]}</span>
                                    <img src={ArrowSelect} />
                                </div>
                            )}
                        </div>
                    </div>
                );
        }
    };

    return (
        <div className="selecting__options">
            <div className="selecting__exit">
                <div className="title">{item?.question}</div>
            </div>
            {layoutRender(item.typeQuestions, item.options)}
        </div>
    );
};

export default SelectingOptions;

const placeholders = {
    metro: "станцию метро",
    region: "ваш регион",
    city: "ваш город",
};
